import {
  WS_SUBSCRIBE,
  WS_UNSUBSCRIBE,
  WS_MESSAGE_RECEIVED,
  WS_START_CHECK_CONNECTION,
  WS_STOP_CHECK_CONNECTION,
  WS_FETCH_DATA, WS_SUBSCRIBE_EVENT, WS_UNSUBSCRIBE_EVENT
} from "../constants/ActionTypes";

export const WSSubscribe = () => ({
  type: WS_SUBSCRIBE,
});

export const WSUnsubscribe = () => ({
  type: WS_UNSUBSCRIBE,
});

// THE WHOLE FRAME, not a projection of it.
//
// This used to destructure `({event, ids})` and rebuild the payload from those two
// keys — which was invisible for as long as `{event, ids}` WAS the whole frame, and
// became a silent data loss the moment an emitter added a field. Manage Routes V2's
// delta sync did exactly that: `ROUTES_DATASET_CHANGED` now also carries `seq`,
// `originator` and `ops` on the SAME frame, and all three were dropped here, one
// call before the saga that fans the frame out. The section's bridge then saw no
// sequence, took its "unknown change" rung, and answered every peer edit with a full
// `GET /dataset` — the exact mechanism delta sync exists to remove, with nothing
// logged and nothing broken on screen.
//
// Copying the frame rather than passing it through keeps the action's payload
// independent of the parsed socket message, and `{...frame}` is a superset of the
// old `{event, ids}` for every caller that had one — including `fetchDataOnConnect`'s
// synthetic, whose missing `ids` reads as `undefined` either way.
export const WSMessageReceived = (frame = {}) => ({
  type: WS_MESSAGE_RECEIVED,
  payload: { ...frame },
});

export const WSStartCheckConnection = () => ({
  type: WS_START_CHECK_CONNECTION,
});

export const WSStopCheckConnection = () => ({
  type: WS_STOP_CHECK_CONNECTION,
});

export const WSFetchAppData = () => ({
  type: WS_FETCH_DATA,
});
export const subscribeWsEvent = (eventType, callback) => ({
  type: WS_SUBSCRIBE_EVENT,
  payload: { eventType, callback },
});

export const unsubscribeWsEvent = (eventType, callback) => ({
  type: WS_UNSUBSCRIBE_EVENT,
  payload: { eventType, callback },
});
